module.exports = __webpack_public_path__ + "img/MS_WeaponSword002.6457d49c.png";